// extracted by mini-css-extract-plugin
export const personTileStyles = "personTile-module--personTileStyles--357sN";
export const headshotStyle = "personTile-module--headshotStyle--RP4e5";
export const flavorPicStyle = "personTile-module--flavorPicStyle--2YEwq";